import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../App';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import UtilizationReport from './UtilizationReport';

const ResourceSelector = ({ projectId }) => {
  const [resources, setResources] = useState([]);
  const [selectedResource, setSelectedResource] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchResources();
  }, [projectId]);

  const fetchResources = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/projects/${projectId}/resources`);
      const humanResources = response.data.filter(r => r.type === 'human');
      setResources(humanResources);
      
      if (humanResources.length > 0) {
        setSelectedResource(humanResources[0]);
      }
    } catch (error) {
      console.error('Failed to fetch resources:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-4">Yükleniyor...</div>;
  }

  if (resources.length === 0) {
    return (
      <div className="text-center py-8 text-gray-600">
        Bu projede henüz insan kaynağı tanımlanmamış
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Select
        value={selectedResource?.id}
        onValueChange={(value) => {
          const resource = resources.find(r => r.id === value);
          setSelectedResource(resource);
        }}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Kaynak seçin" />
        </SelectTrigger>
        <SelectContent>
          {resources.map(resource => (
            <SelectItem key={resource.id} value={resource.id}>
              {resource.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {selectedResource && (
        <UtilizationReport
          resourceId={selectedResource.id}
          resourceName={selectedResource.name}
        />
      )}
    </div>
  );
};

export default ResourceSelector;
